import Logo from '../../assets/skyfirst-logo.png'
export default {
  name: 'heading',
  data: () => {
    return {
      logo: Logo
    }
  }
}
